import { useEffect, useState } from "react";
import { filterCountries } from "../../utils/methods";
import useStore from "../../store/index";
import SelectInputField, { InputField } from '../../components/Input';
import { addClaimantValidation } from "../../requests/createCase";
import { ErrorStatus } from '../FormStatus';

export function AddMediatorModal({ onSubmit, initState, onClose, title }) {

    const [formState, setFormState] = useState({
        name: '',
        email: '',
        phone: '',
        country: '',
        state: '',
    });

    const countries = useStore((state) => state.countries)

    const [errors, setErrors] = useState([]);
    const [filteredCountries, setFilteredCountries] = useState([]);
    const [states, setStates] = useState([]);


    const handleInputChamge = (val, name) => {
        formState[name] = val;

    }

    const cancelCreation = () => {
        setFormState({
            name: '',
            email: '',
            phone: '',
            country: '',
            state: '',
        })
        onClose();
    }



    useEffect(() => {
        if (initState !== {}) {
            let stateInit = {
                name: initState.name,
                email: initState.email,
                phone: initState.phone,
                country: initState.country,
                state: initState.state,
            }
            setFormState(stateInit);
        }

        setFilteredCountries(filterCountries(countries));
    }, [])

    const submitForm = async () => {
        await addClaimantValidation.validate(formState).then(() => {
            onSubmit(formState);
            cancelCreation();
        }).catch((e) => {
            setErrors(e.errors)
        })
    }


    useEffect(() => {

        let countriesObject = Object.values(countries);
        let countryStates = [];
        let findCountryIndex = countriesObject.findIndex((cj) => cj.name === formState.country)
        if (findCountryIndex) {
            countryStates = countriesObject[findCountryIndex]
            if (countryStates && countryStates['states']) {
                let filteredStates = countryStates['states'].map((st) => st.name)
                setStates(filteredStates)
            }
        }
    }, [formState.country])


    return (
        <div className="fixed animate__animated animate__fadeIn w-screen h-screen modal-dialog-bg z-20 shadow-md md:px-8 px-4 left-0 top-0">
            <div className="relative w-full flex h-full justify-center items-center">
                <div className="lg:w-2/5 px-8 w-full bg-white py-8 rounded-xl">


                    <form onSubmit={(e) => {
                        e.preventDefault();
                        submitForm();
                    }}>

                        <h4 className="mb-4 text-lg font-semibold">{title} </h4>
                        {errors.length > 0 && <ErrorStatus errors={errors} />}
                        <div className="mb-6">
                            <InputField
                                onChange={(e) => {
                                    setErrors([]);
                                    handleInputChamge(e.target.value, 'name')
                                }}
                                isRequired={true} type="text" placeholder="Mike Jones" name="fullname" defaultValue={formState.name} label="Mediator Full name" />
                            <InputField
                                onChange={(e) => {
                                    setErrors([]);
                                    handleInputChamge(e.target.value, 'email')
                                }}
                                isRequired={true} type="email" placeholder="example@domain.com" defaultValue={formState.email} name="email" label="Mediator Email" />

                            <InputField isRequired={true} type="text" placeholder="+1 8806 0098" onChange={(e) => {
                                setErrors([]);
                                handleInputChamge(e.target.value, 'phone')
                            }} defaultValue={formState.phone} name="phone" id="phone" label="Phone" />

                            <SelectInputField isRequired={true} placeholder="Country" onChange={(e) => {
                                setErrors([]);
                                handleInputChamge(e.target.value, 'country')
                            }} name="country" defaultValue={formState.country} id="country" label="Country" options={filteredCountries} />

                            <SelectInputField isRequired={true} placeholder="State" onChange={(e) => {
                                setErrors([]);
                                handleInputChamge(e.target.value, 'state')
                            }} name="state" id="state" defaultValue={formState.state} label="State/Province" options={states.length > 0 ? states : []} />
                        </div>

                        <div className="flex text-xs font-semibold gap-3">
                            <button onClick={cancelCreation} className="w-1/2 text-red-800 border-red-800 hover:border-red-900 py-2 flex justify-center items center border-2 rounded-lg ">
                                <span>
                                    Close
                                </span>
                            </button>
                            <button className="w-1/2 py-2 flex justify-center items center border-2 border-blue-800 text-white bg-blue-800 hover:bg-blue-900 rounded-lg ">
                                <span>
                                    {title}
                                </span>
                            </button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    )
}
